import { render, staticRenderFns } from "./AddBoardMember.vue?vue&type=template&id=1a4d2d20&scoped=true"
import script from "./AddBoardMember.vue?vue&type=script&lang=js"
export * from "./AddBoardMember.vue?vue&type=script&lang=js"
import style0 from "./AddBoardMember.vue?vue&type=style&index=0&id=1a4d2d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d2d20",
  null
  
)

export default component.exports